import React, { Suspense } from 'react';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';
import Routes from './Route.config';
import history from '../store/history';
import ContentContext from '../utils/ContentContext';
import Loader from '../common/components/loader';
import ProtectedRoute from './ProtectedRoute';
import HeaderContainer from "../common/components/header/Header";
import NoResultsMsgBlock from "../common/components/NoResultsMsgBlock";
import bsBreakpoints from '../utils/BsBreakpoint';

import  ErrAuthImg from "../design-system/design_system/assets/illustrations/system/error/system-error.svg"
import GlobalTagManager from "../common/gtm/GlobalTagManager";
import { getCookie } from '../utils/AEMUtils';
import handleSessionExtend from '../modules/session';

class RouteComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isAEMContentValue: false,
      contentFlagSet: false,
    };
  }
  componentDidMount() {
    const { MULTI_TAB_SESSION } = window.weeksWebCloudConfig;
    const CMSPostMessageListner = (event) => {
      if (event.data.type === 'naviagetionEventFromFooter') {
        history.push(event.data.url);
        document.dispatchEvent(new CustomEvent('footerEvent', {
          detail: { ...event.data },
        }));
      } else if (event.data.type === 'typeAheadSelection'
        || event.data.type === 'naviagetionEvent'
        || event.data.type === 'resortdirectory'
        || event.data.type === 'productTypeSelection'
        || event.data.type === 'allResortSearch'
        || event.data.type === 'typeAheadData'
        || event.data.type === 'rciImageLoad'
        || event.data.type === 'selectedSuggestion') {
        document.dispatchEvent(new CustomEvent('headerEvent', {
          detail: { ...event.data },
        }));
      }
    };

    bsBreakpoints.init();
    bsBreakpoints.detectBreakpoint();
    window.removeEventListener('message', CMSPostMessageListner);
    window.addEventListener('message', CMSPostMessageListner);
    MULTI_TAB_SESSION && handleSessionExtend();

  }
  static getDerivedStateFromProps(props, state) {
    const { contentFlagSet } = state;
    if (!contentFlagSet) {
      const isAEMContentDependency = JSON.parse(getCookie('AEM_POST_FLAG'));
      return {
        isAEMContentValue: isAEMContentDependency,
        contentFlagSet: true,
      };
    }
    return false;
  }
 render() {
    const {
      history,
      authStatus,
      authenticating
    } = this.props;
    const { isAEMContentValue } = this.state;

    if(authStatus)
     return (
      <>
      <Suspense fallback={<Loader/>}>
        {!isAEMContentValue && <HeaderContainer />}
        <ContentContext.Provider value={isAEMContentValue}>
          <Switch>
                {Routes.map(route => (
                  <ProtectedRoute
                    path={route.path}
                    exact={route.exact}
                    component={route.component}
                    key={route.id}
                    routeConfig={route}
                    history={history}
                  />
              ))}
            </Switch>
          {<GlobalTagManager />}
          </ContentContext.Provider>
      </Suspense>  
      </>
    );
    else if(!authStatus && authenticating){
      return <Loader />
    }
    else if(!authStatus && !authenticating){
      return <NoResultsMsgBlock noresultsImg={ErrAuthImg} noResultsMessage= {"User not Authenticated"} noResultsUrl='/pre-rci-en_US/navigation/campaign-bypass.page' noResultBtnText={"Sign in"}/>
    }
  }
}

const mapStateToProps = (state) => ({
  authStatus: state.CommonReducer.authStatus,
  authenticating: state.CommonReducer.authenticating
  
});

export default connect(
  mapStateToProps
)(RouteComponent);
